import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import { useDispatch } from 'react-redux';
import {
  FlashMessage,
  Heading,
  InputTiles,
  SectionWrapper,
  SheetLayoutContent,
  SheetLayoutContentWrapper,
  SheetLayoutHeader,
} from '../../../../brenger-shared-ui';
import { useTypedSelector } from '../../../../hooks';
import { translate } from '../../../../utils/localization';
import { actions } from '../../ducks';
import { proceed } from '../../proceed';
import FooterLayout from '../../containers/FooterLayout';
import { useLocation } from 'react-router-dom';

export const ProductPaymentOptIn: React.FC = () => {
  const homeSituation = useTypedSelector(state => state.generalTransport.choices?.home_situation);
  const ppOptIn = useTypedSelector(state => state.generalTransport.choices?.product_payment_otp_in);
  const dispatch = useDispatch();

  const [showError, setShowError] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    dispatch(actions.setProgress(3));
    dispatch(actions.resetChoice(['product_payment_otp_in', 'product_payment_amount']));
  }, [location.pathname]);

  return (
    <SheetLayoutContentWrapper>
      <SheetLayoutHeader>
        <Heading size={2} extraClasses={'no-margin pb-[0.5em]'}>
          <Translate
            id={'request_flow.headers.product_payment_opt_in'}
            data={{
              market_place:
                homeSituation !== 'acquaintances'
                  ? translate(`request_flow.home_situation.fields.type.options.${homeSituation}.name`)
                  : '',
            }}
          />
        </Heading>
      </SheetLayoutHeader>
      <SectionWrapper centerContent={false} sectionStyle={'white'}>
        <SheetLayoutContent>
          <div className={'question-wrapper'}>
            <InputTiles
              value={ppOptIn}
              id={'situation'}
              name={'situation'}
              options={[
                {
                  title: translate('request_flow.product_payment.fields.opt_in.options.yes.label'),
                  desc: translate('request_flow.product_payment.fields.opt_in.options.yes.desc'),
                  value: true,
                },
                {
                  title: translate('request_flow.product_payment.fields.opt_in.options.no.label'),
                  desc: translate('request_flow.product_payment.fields.opt_in.options.no.desc'),
                  value: false,
                },
              ]}
              onChange={newPpOptIn => {
                dispatch(actions.setChoice({ product_payment_otp_in: newPpOptIn as boolean }));
                proceed();
              }}
            />
          </div>
          {showError && (
            <div className={'general-errors-wrapper'}>
              <FlashMessage type={'error'} message={translate('request_flow.errors.select_required')} />
            </div>
          )}
        </SheetLayoutContent>
      </SectionWrapper>
      <FooterLayout customSubmitFunction={() => (ppOptIn ? proceed() : setShowError(true))} />
    </SheetLayoutContentWrapper>
  );
};
